import { FC, useState, useEffect } from "react"
import { makeStyles } from '@material-ui/styles';
import {
    Button,
} from '@material-ui/core';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import { setImageFromBlob } from "../commons/utils";
import clsx from "clsx";

const useStyles = makeStyles((theme?: any) => ({
    button: {
        height: "40px",
        width: "40px",
        borderRadius: theme.shape.circle,
        display: "flex",
        justifyContent: "center",
        padding: theme.spacing(0),
        minWidth: "40px",
        "& .MuiButton-startIcon": {
            marginLeft: theme.spacing(0),
            marginRight: theme.spacing(0)
        },
        "& .MuiButton-label": {
            width: "auto",
        }, 
        "&:focus": {
            outline: "none",
        },
        "&:hover": {
            background: "none"
        }
    },
    logo: {
        height: "40px",
        width: "40px",
        borderRadius: theme.shape.circle,
    },
    menuIcon: {
        height: "20px",
        width: "20px",
        // transform: "rotate(90deg)"
    },
    dittoLogoButton: {
        width: "100%",
        margin: "8px auto"
    },
    scaleLogoButton: {
        width: "40px"
    },
    dittoLogo: {
        borderRadius: 0,
        width: "unset"
    },
    scaleLogo: {
        transform: "scale(0.5)"
    }
}))

interface MenuItemButtonProps {
    open?: boolean
    handleClick?: any
    transform?: boolean
    icon: string
    logo?: any,
    scaleLogo?: boolean
  }

const MenuItemLogo: FC<MenuItemButtonProps> = ({
    open, 
    handleClick, 
    transform, 
    icon, 
    logo,
    scaleLogo = false
}) => {
    const classes = useStyles()
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
    const [src, setSrc] = useState("")
    
        useEffect(()=>{       
            setImageFromBlob(logo, setSrc)    
        }, [logo])

    return (
        <Button
            disableRipple
            startIcon={
                    <img 
                        src={logo ? src : icon} 
                        alt="menu icon"
                        className={clsx(classes.logo, {
                            [classes.menuIcon]: isMobile,
                            [classes.dittoLogo]: transform,
                            [classes.scaleLogo]: scaleLogo
                        })}
                    />               
            }
            onClick={()=>handleClick && handleClick()}
            classes={{root: clsx(classes.button, { [classes.dittoLogoButton]: transform, [classes.scaleLogoButton]: scaleLogo })}} 
        />
    )
}

export default MenuItemLogo
